module.exports = __webpack_public_path__ + "static/3280-genesis-62da5531e6f564fd81b8156dbf6013ce.png";